/* eslint-disable import/no-cycle */
import { Box, Stack, Text } from '@chakra-ui/core';
import React from 'react';
import { isFieldSchema, isSectionSchema } from '../../utils';
import { FormSectionT } from '../../types';
import ElementPreview from './ElementPreview';

export default function SectionPreview({ schema, language }: { schema: FormSectionT; language: string }) {
  return (
    <Box>
      <Text fontWeight="bold" fontSize="xs">
        {schema.section}
      </Text>
      <Stack spacing={2}>
        {schema.fields
          ?.filter((field) => isFieldSchema(field) && !field?.isFrontEndOnly)
          .map((field) =>
            isSectionSchema(field) ? (
              <SectionPreview key={field.id} schema={field} language={language} />
            ) : (
              <ElementPreview key={field.id} schema={field} language={language} />
            ),
          )}
      </Stack>
    </Box>
  );
}
